import axios from 'axios';
import {API_BASE_URL} from '../config';


const logsUserService = async (user_id, action, urlCampaign) => {
    try {
        await axios.post(`${API_BASE_URL}logs-user/`, {
            user_id,
            action,
            urlCampaign
        });
    } catch (error) {
        throw new Error(error);
    }
}

export default logsUserService;